import CheckFilledIcon from '@/components/Icons/CheckFilledIcon';
import ScheduleTourForm from '@/components/ScheduleTourForm/ScheduleTourForm';
import ScheduleTourPropertyDetails from '@/components/ScheduleTourPropertyDetails/ScheduleTourPropertyDetails';
import type { Unit } from '@/domain/units';
import { getUnitShowingLink } from '@/utils/links';
import { useState, type FC } from 'react';

interface Props {
  unit: Unit;
}

const ScheduleTourCard: FC<Props> = ({ unit }) => {
  const [leadCreated, setLeadCreated] = useState(false);

  return (
    <div className="bg-white p-8 rounded-none border border-gray-200">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Schedule a Tour</h2>

      <ScheduleTourPropertyDetails unitId={unit.id} />

      {leadCreated ? (
        <div className="bg-sage-50 border border-sage-200 text-sage-800 px-6 py-4 rounded-none">
          <div className="flex items-center">
            <CheckFilledIcon />
            <div>
              <h3 className="font-semibold">Thank you!</h3>
              <p className="text-sm">
                We&apos;ve received your tour request and will contact you shortly.
              </p>
            </div>
          </div>
        </div>
      ) : (
        <ScheduleTourForm
          onSuccess={() => setLeadCreated(true)}
          getRedirectTo={getUnitShowingLink}
          submitButtonText="Schedule Tour"
          unit={unit}
          showDisclaimer
        />
      )}
    </div>
  );
};

export default ScheduleTourCard;
